const $el        = $(el);
const $btnMobile = $el.find('.box-menu-mobile');
const $hamburger = $el.find('.btn-menu-mobile');
const $menu      = $el.find('[data-component="cosplayer/menu"]');

const open = () => {
    $hamburger.toggleClass('is-active');
    $menu.slideToggle();
    $el.toggleClass('menu-open');
};

const close = () => {
    $hamburger.removeClass('is-active');
    $menu.slideUp();
    $el.removeClass('menu-open');
};

$btnMobile.on('click', function(){
    open();
});

$body.on('click', function (e) {
    if ($hamburger.is('.is-active') && !$(e.target).closest('[data-component="cosplayer/header"]').length) {
        close();
    }
});

$window
    .on('resize', function() {
        if (wW > 980) {
            $el.removeClass('menu-open');
            $hamburger.removeClass('is-active');
            $menu.attr('style', '');
        }
    });